import {
  SA_COLLECTION_ADD,
  SA_COLLECTION_SUCCESS,
  SA_COLLECTION_FAIL,
  SA_GET_COLLECTION_LISTING,
  SA_GET_COLLECTION_LISTING_SUCCESS,
  SA_GET_COLLECTION_LISTING_FAILED,
  SA_COLLECTION_EDIT,
  SA_COLLECTION_EDIT_SUCCESS,
  SA_COLLECTION_EDIT_FAIL,
  SA_COLLECTION_UPDATE,
  SA_COLLECTION_UPDATE_SUCCESS,
  SA_COLLECTION_UPDATE_FAIL,
  SA_COLLECTION_DELETE,
  SA_COLLECTION_DELETE_SUCCESS,
  SA_COLLECTION_DELETE_FAIL,
  SA_EXPORTCOLLECTIONCATALOG_DOWNLOAD,
  SA_EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS,
  SA_EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL,
  SA_COLLECTION_COPY,
  SA_COLLECTION_COPY_SUCCESS,
  SA_COLLECTION_COPY_FAIL,
  SA_EXPORTDOWNLOAD_PROGRESS,
  SA_EXPORTDOWNLOAD_PROGRESS_SUCCESS,
  SA_EXPORTDOWNLOAD_PROGRESS_FAIL,
  SA_ADD_MORE_TO_COLLECTION,
  SA_ADD_MORE_TO_COLLECTION_SUCCESS,
  SA_ADD_MORE_TO_COLLECTION_FAIL,
  SA_ADD_MORE_TO_COLLECTION_UPDATE,
  SA_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS,
  SA_ADD_MORE_TO_COLLECTION_UPDATE_FAIL,
  SA_GET_PRODUCTS_FOR_ADD_COLLECTION,
  SA_GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS,
  SA_GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL,
  SA_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION,
  SA_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS,
  SA_GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL,
  SA_REFRESH_COLLECTION_COUNT,
  SA_REFRESH_COLLECTION_COUNT_SUCCESS,
  SA_REFRESH_COLLECTION_COUNT_FAIL,
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  msg: null,
  collection: null,
  collectionEdit: null,
  collectionUpdate: null,
  collectionDelete: null,
  exportCollection: null,
  collectionCopy: null,
  saExportDownloadProgress: null,
  collectionAddMore: null,
  addMoreUpdateDetails: null,
  productsForAddCollection: null,
  productsOfferForAddCollection: null,
}

export const saCollection = (state = initialState, action) => {
  switch (action.type) {
    case SA_COLLECTION_ADD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collection: action.payload,
      }
      break
    case SA_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case SA_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_GET_COLLECTION_LISTING:
      state = {
        ...state,
        loading: true,
        msg: null,
        error: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case SA_GET_COLLECTION_LISTING_SUCCESS:
      state = {
        ...state,
        error: null,
        loading: false,
        msg: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case SA_GET_COLLECTION_LISTING_FAILED:
      state = {
        ...state,
        loading: false,
        msg: null,
        collectionAddMore: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_COLLECTION_EDIT:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionEdit: action.payload,
      }
      break
    case SA_COLLECTION_EDIT_SUCCESS:
      if (state === null || state.collection.length === 0) {
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          collection: [...state.collection, action.payload],
        }
      } else {
        state = {
          ...state,
          loading: false,
          msg: null,
          collection: state.collection.map(i =>
            i.id === action.payload.id ? action.payload : i
          ),
        }
      }
      break
    case SA_COLLECTION_EDIT_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_COLLECTION_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionUpdate: action.payload,
      }
      break
    case SA_COLLECTION_UPDATE_SUCCESS:
      state = { ...state, error: null, msg: null, loading: false }
      break
    case SA_COLLECTION_UPDATE_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_COLLECTION_DELETE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionDelete: action.payload,
      }
      break
    case SA_COLLECTION_DELETE_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: state.collection.filter(collection => {
          return collection.id !== action.payload.id
        }),
      }
      break
    case SA_COLLECTION_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_EXPORTCOLLECTIONCATALOG_DOWNLOAD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        exportCollection: action.payload,
      }
      break
    case SA_EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS:
      state = {
        ...state,
        error: null,
        msg: null,
        loading: false,
        exportCollection: action.payload,
      }
      break
    case SA_EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_COLLECTION_COPY:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionCopy: action.payload,
      }
      break
    case SA_COLLECTION_COPY_SUCCESS:
      let newcol = [...state.collection, action.payload]
      newcol = newcol.sort(function (a, b) {
        return b.id - a.id || b.id.localeCompare(a.id)
      })
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: newcol,
        collectionCopy: null,
      }
      break
    case SA_COLLECTION_COPY_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_EXPORTDOWNLOAD_PROGRESS:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        saExportDownloadProgress: action.payload,
      }
      break
    case SA_EXPORTDOWNLOAD_PROGRESS_SUCCESS:
      state = {
        ...state,
        error: null,
        msg: null,
        loading: false,
        saExportDownloadProgress: action.payload,
      }
      break
    case SA_EXPORTDOWNLOAD_PROGRESS_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_ADD_MORE_TO_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionAddMore: action.payload,
      }
      break
    case SA_ADD_MORE_TO_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collectionAddMore: action.payload,
      }
      break
    case SA_ADD_MORE_TO_COLLECTION_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_ADD_MORE_TO_COLLECTION_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        addMoreUpdateDetails: action.payload,
      }
      break
    case SA_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        addMoreUpdateDetails: null,
      }
      break
    case SA_ADD_MORE_TO_COLLECTION_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_GET_PRODUCTS_FOR_ADD_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: action.payload,
      }
      break
    case SA_GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        productsForAddCollection: action.payload,
      }
      break
    case SA_GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        productsForAddCollection: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case SA_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case SA_GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
      case SA_REFRESH_COLLECTION_COUNT:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          productsForAddCollection: null,
          productsOfferForAddCollection: action.payload,
        }
        break
      case SA_REFRESH_COLLECTION_COUNT_SUCCESS:
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          collection: state.collection.map(i =>
            i.id === action.payload.id ? action.payload : i
          ),
        }
        break
      case SA_REFRESH_COLLECTION_COUNT_FAIL:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
  }
  return state
}

export default saCollection
